export default "__VITE_ASSET__wqgHg86a__"